import * as React from 'react';

import {Checkbox} from './checkbox';
import {CheckboxGroupContext} from './checkbox-group';

import styles from './checkbox-for-group.module.css';

type Props = {
    disabled?: boolean;
    value: string;
    children: React.ReactNode;
    hasError?: boolean;
    isLarge?: boolean;
};

export class CheckboxForGroup extends React.Component<Props> {
    static defaultProps = {
        isLarge: true,
    };

    render() {
        return (
            <CheckboxGroupContext.Consumer>
                {/* @ts-expect-error */}
                {({selectedValues, onChange}) => {
                    const checked = selectedValues.includes(this.props.value);

                    return (
                        <div className={styles.checkbox}>
                            <Checkbox
                                label={this.props.children}
                                isLarge={this.props.isLarge}
                                hasError={this.props.hasError}
                                // @ts-expect-error
                                type='checkbox'
                                role='checkbox'
                                checked={checked}
                                aria-checked={checked}
                                disabled={this.props.disabled}
                                onChange={(nowChecked: boolean) =>
                                    this.handleChange(nowChecked, selectedValues, onChange)
                                }
                            />
                        </div>
                    );
                }}
            </CheckboxGroupContext.Consumer>
        );
    }

    handleChange = (
        checked: boolean,
        previousValues: string[],
        onChange: (...args: any) => any
    ) => {
        if (checked) {
            onChange(previousValues.concat([this.props.value]));
        } else {
            onChange(previousValues.filter((item) => item !== this.props.value));
        }
    };
}
